import React from 'react';
import { IconProps } from '../types';
const MinecraftSpawnEggOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="3" width="1" height="1" fill="rgba(128, 128, 128, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(128, 128, 128, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(126, 126, 126, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(128, 128, 128, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(163, 163, 163, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(167, 167, 167, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(142, 142, 142, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(121, 121, 121, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(127, 127, 127, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(166, 166, 166, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(183, 183, 183, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(175, 175, 175, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(206, 206, 206, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(203, 203, 203, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(163, 163, 163, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(203, 203, 203, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(222, 222, 222, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(190, 190, 190, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(125, 125, 125, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(163, 163, 163, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(226, 226, 226, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(124, 124, 124, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(194, 194, 194, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(127, 127, 127, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(163, 163, 163, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(111, 111, 111, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(163, 163, 163, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(128, 128, 128, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(134, 134, 134, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(117, 117, 117, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(110, 110, 110, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(110, 110, 110, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(117, 117, 117, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(119, 119, 119, 255)" />
</svg>);
export default MinecraftSpawnEggOverlay;